<header class="nh-area">
  <div class="nh-mobile-wrapper">
    <div class="nh-container nh-mobile-menu">
      <a routerLink="/" class="nh-brand" aria-label="Eplog Properties home" (click)="closeMenu()">
        <span class="nh-brand-logo" aria-hidden="true"></span>
      </a>

      <button class="nh-menu-toggle" type="button" (click)="isEnable = !isEnable"
        [attr.aria-expanded]="isEnable" aria-controls="mobile-navigation"
        [attr.aria-label]="isEnable ? 'Close menu' : 'Open menu'">
        @if (!isEnable) {
          <span class="nh-hamburger" aria-hidden="true"><span></span><span></span><span></span></span>
        } @else {
          <span class="nh-close" aria-hidden="true">×</span>
        }
      </button>

      @if (isEnable) {
        <nav id="mobile-navigation" class="nh-mobile-nav-list" aria-label="Mobile navigation">
          <ul class="nh-nav-list">
            <li><a routerLink="/" routerLinkActive="nh-active" [routerLinkActiveOptions]="{exact:true}"
                (click)="closeMenu()">Home</a></li>
            <li class="nh-mobile-dropdown">
              <div class="nh-mobile-dropdown-row">
                <a routerLink="/offplanproject" (click)="closeMenu()">Off Plan</a>
                <button type="button" (click)="toggleOffplanMenu()" [attr.aria-expanded]="isOffplanSubMenu"
                  aria-label="Toggle Off Plan menu">{{ isOffplanSubMenu ? '−' : '+' }}</button>
              </div>
              @if (isOffplanSubMenu) {
                <ul class="nh-mobile-submenu">
                  @for (item of stateList; track item.id || item.name) {
                    <li><a [routerLink]="'/offplanproject/' + (item.name | textTransform)"
                        (click)="closeMenu()">{{ item.name }}</a></li>
                  }
                  <li><a routerLink="/offplanproject" (click)="closeMenu()">All Projects</a></li>
                </ul>
              }
            </li>
            <li class="nh-mobile-dropdown">
              <div class="nh-mobile-dropdown-row">
                <a routerLink="/renovation-development" routerLinkActive="nh-active"
                  (click)="closeMenu()">Build, Renovate &amp; Reposition</a>
                <button type="button" (click)="toggleBuildMenu()" [attr.aria-expanded]="isBuildSubMenu"
                  aria-label="Toggle Build, Renovate and Reposition menu">{{ isBuildSubMenu ? '−' : '+' }}</button>
              </div>
              @if (isBuildSubMenu) {
                <ul class="nh-mobile-submenu">
                  <li><a routerLink="/renovation-development" (click)="closeMenu()">Overview</a></li>
                  <li><a routerLink="/renovation-development/villa-flipping-investment-management"
                      (click)="closeMenu()">Villa Flip &amp; Investment Management</a></li>
                  <li><a routerLink="/renovation-development/calculators"
                      (click)="closeMenu()">Investment Calculators</a></li>
                </ul>
              }
            </li>
            <li><a routerLink="/eplog-services" routerLinkActive="nh-active" (click)="closeMenu()">Services</a></li>
            <li><a routerLink="/blog" routerLinkActive="nh-active" (click)="closeMenu()">News &amp; Articles</a></li>
            <li><a routerLink="/contact-us" routerLinkActive="nh-active" (click)="closeMenu()">Contact Us</a></li>
            <li class="nh-mobile-cta"><a routerLink="/contact-us" (click)="closeMenu()">Enquire</a></li>
          </ul>
        </nav>
      }
    </div>
  </div>

  <div class="nh-desktop-wrapper">
    <div class="nh-container">
      <nav class="nh-navbar" aria-label="Primary navigation">
        <a routerLink="/" class="nh-brand" aria-label="Eplog Properties home">
          <span class="nh-brand-logo" aria-hidden="true"></span>
        </a>
        <ul class="nh-nav-list">
          <li><a routerLink="/" routerLinkActive="nh-active" [routerLinkActiveOptions]="{exact:true}">Home</a></li>
          <li class="nh-dropdown">
            <a routerLink="/offplanproject" routerLinkActive="nh-active">Off Plan <span aria-hidden="true">⌄</span></a>
            <ul class="nh-dropdown-menu" aria-label="Off Plan">
              @for (item of stateList; track item.id || item.name) {
                <li><a [routerLink]="'/offplanproject/' + (item.name | textTransform)">{{ item.name }}</a></li>
              }
              <li><a routerLink="/offplanproject">All Projects</a></li>
            </ul>
          </li>
          <li class="nh-dropdown">
            <a routerLink="/renovation-development" routerLinkActive="nh-active">Build, Renovate &amp; Reposition <span aria-hidden="true">⌄</span></a>
            <ul class="nh-dropdown-menu" aria-label="Build, Renovate and Reposition">
              <li><a routerLink="/renovation-development">Overview</a></li>
              <li><a routerLink="/renovation-development/villa-flipping-investment-management">Villa Flip &amp; Investment Management</a></li>
              <li><a routerLink="/renovation-development/calculators">Investment Calculators</a></li>
            </ul>
          </li>
          <li><a routerLink="/eplog-services" routerLinkActive="nh-active">Services</a></li>
          <li><a routerLink="/blog" routerLinkActive="nh-active">News &amp; Articles</a></li>
          <li><a routerLink="/contact-us" routerLinkActive="nh-active">Contact Us</a></li>
          <li><a routerLink="/contact-us" class="nh-enquire">Enquire</a></li>
        </ul>
      </nav>
    </div>
  </div>
</header>
